import { Env } from 'config/Env'
import {
  OrganizationDetailsRequest,
  PromiseFeatureForm,
  OrganizationCreateResponse,
  OrganizationGetResponse,
  FeatureListResponse,
  QuestionBank,
  CreateCategory,
  UpdateCategory,
  AddKeywordDataResponse,
  AddKeywordRequest,
  WordBankSelectedDeatil,
  ListData,
  OrganizationStatusRequest,
  UpdateQuestionBankPriorityReq,
  AIForQAStatus,
  AutomationConfig,
  RuleAssignUserListReq,
  RulesAssignRoleListReq,
  RulesListRequest,
  CapabilityReq,
  CommunityCapabilityStatusReq,
  UploadCommunityCapabilityParams,
  UploadFileResponse,
  BulkUploadCentralizedFaxParams,
  BulkUploadCentralizedFaxResponse,
} from 'features/organization/types'
import { DropDownEnvelope } from 'utils/types/DropDownEnvelope'
import { Envelope } from 'utils/types/Envelope'

import { HttpClient, ApiRequestTypes } from '../../../utils/apiService/httpService'
import {
  BulkUploadDrugPriceParams,
  BulkUploadDrugPriceResponse,
  DrugPriceListRequest,
  DrugPriceListResponse,
  DrugPriceSaveRequest,
  DrugPriceStringResponse,
  DrugPriceThresholdResponse,
  DrugDetailResponse,
  DrugPriceUpdateRequest,
  NadacDrugSearchRequest,
  NadacDrugSearchResponse,
  OrgDrugCommunityPriceRequest,
  OrgDrugCommunityPriceResponse,
  SaveThresholdRequest,
} from '../types/drugPriceConfigTypes'
import { AddHraRequest } from '../types/hraTypes'
import { RulePayload } from '../types/rulesTypes'
import {
  GetOptOutStatusThresholdResponse,
  GetStatusThresholdByOrgAndStatusRequest,
  SaveStatusThresholdRequest,
  SaveStatusThresholdResponse,
  SetOptOutStatusThresholdRequest,
  SetOptOutStatusThresholdResponse,
  StatusThresholdDetailResponse,
  StatusThresholdListResponse,
} from '../types/statusThresholdTypes'

const ORGANIZATION_CREATE_BASE_URL = `${Env.REACT_APP_API_URL}Organization/api/Organization/create`
const GET_ALL_FEATURES_URL = `${Env.REACT_APP_API_URL}Organization/api/feature/get`
const ORGANIZATION_DELETE_BASE_URL = `${Env.REACT_APP_API_URL}Organization/api/Organization/delete`
const GET_ORGANIZATION_DATA = `${Env.REACT_APP_API_URL}Organization/api/Organization/getbyid`
const PUT_ORGANIZATION_DATA = `${Env.REACT_APP_API_URL}Organization/api/Organization/update`
const GET_ORGANIZATION_DETAILS = `${Env.REACT_APP_API_URL}Organization/api/Organization/getdetailbyid`
const GET_QUESTION_BANK_DETAIL_LIST = `${Env.REACT_APP_API_URL}Organization/api/QuestionBank/GetAllQuestionBank`
const ADD_OR_UPDATE_QUESTIONBANK_URL = `${Env.REACT_APP_API_URL}Organization/api/QuestionBank/SaveQuestionBank`
const QUESTION_DELETE_URL = `${Env.REACT_APP_API_URL}Organization/api/QuestionBank/DeleteQuestion`

const ADD_CATEGORY_URL = `${Env.REACT_APP_API_URL}Organization/api/Category/create`
const UPDATE_CATEGORY_URL = `${Env.REACT_APP_API_URL}Organization/api/Category/update`
const GET_CATEGORIES_URL = `${Env.REACT_APP_API_URL}Organization/api/FacilityCategory/GetAllCategoryById`

const GET_ALL_FACILITY_URL = `${Env.REACT_APP_API_URL}Organization/api/Facility/GetListByOrganizationId`
const ADD_KEYWORD_URL = `${Env.REACT_APP_API_URL}Organization/api/Wordbank/saveWordBank`
const GET_SAVED_KEYWORDS_URL = `${Env.REACT_APP_API_URL}Organization/api/Wordbank/GetDetailbyCategoryId`
const GET_WORD_BANK_DETAIL_LIST_URL = `${Env.REACT_APP_API_URL}Organization/api/Wordbank/GetWordBankDetailbyOrganizationId`
const GET_CATEGORIES_FOR_ADDMORE_URL = `${Env.REACT_APP_API_URL}Organization/api/Category/GetCategoryListForAddMore`
const DELETE_WORD_BANK_URL = `${Env.REACT_APP_API_URL}Organization/api/Wordbank/delete`
const PUT_ORGANIZATION_STATUS = `${Env.REACT_APP_API_URL}Organization/api/Organization/OrganizationStatusUpdate`
const DELETE_CATEGORY_URL = `${Env.REACT_APP_API_URL}Organization/api/Category/DeleteCategory`
const UPDATE_PRIORITY_URL = `${Env.REACT_APP_API_URL}Organization/api/QuestionBank/UpdateQuestionBankPriority`
const CREATE_HRA = `${Env.REACT_APP_API_URL}Referral/api/HighRiskAdmission/CreateHighRiskAdmission`
const HAS_AI_CONFIGURED = `${Env.REACT_APP_API_URL}Organization/api/Organization/IsAIEnabledForQA`
const GET_AUTOMATION_CONFIGS_URL = `${Env.REACT_APP_API_URL}Organization/api/FeatureAutomation/GetFeatureAutomationConfigs`
const UPDATE_AUTOMATION_CONFIGS_URL = `${Env.REACT_APP_API_URL}Organization/api/FeatureAutomation/UpdateFeatureAutomationConfigs`
const BULK_UPLOAD_CENTRALIZED_FAX_URL = `${Env.REACT_APP_API_URL}Organization/api/Organization/BulkUploadCentralizedFaxNumbers`
const GET_RULE_CONFIG_BY_ID = `${Env.REACT_APP_API_URL}Referral/api/RuleConfiguration/GetRuleConfigurationById`
const CREATE_RULE = `${Env.REACT_APP_API_URL}Referral/api/RuleConfiguration/CreateRule`
const UPDATE_RULE = `${Env.REACT_APP_API_URL}Referral/api/RuleConfiguration/UpdateRule`
const GET_RULE_ASSIGN_ROLES_LIST = `${Env.REACT_APP_API_URL}Identity/api/ApplicationRole/GetRuleAssignRolesList`
const GET_RULE_ASSIGN_USERS_LIST = `${Env.REACT_APP_API_URL}Identity/api/User/GetRuleAssignUsersByRoleId`
const GET_COMMUNITY_CAPABILITIES = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/GetAll`
const CREATE_COMMUNITY_CAPABILITIES = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/Create`
const UPDATE_COMMUNITY_CAPABILITIES = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/Update`
const DELETE_COMMUNITY_CAPABILITIES = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/Delete`
const UPDATE_STATUS_COMMUNITY_CAPABILITIES = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/UpdateStatus`
const BULK_UPLOAD_COMMUNITY_CAPABILITIES = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/BulkUpload`
const GET_CAPABILITIES_BY_ID = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/GetCapabilityMappingsById`
const GET_STATUS_THRESHOLD_LIST = `${Env.REACT_APP_API_URL}Referral/api/StatusThresholdConfiguration/GetAllByOrganizationId`
const GET_STATUS_THRESHOLD_BY_STATUS = `${Env.REACT_APP_API_URL}Referral/api/StatusThresholdConfiguration/GetByOrganizationAndStatus`
const SAVE_STATUS_THRESHOLD = `${Env.REACT_APP_API_URL}Referral/api/StatusThresholdConfiguration/Save`
const GET_OPT_OUT_STATUS_THRESHOLD = `${Env.REACT_APP_API_URL}Organization/api/Organization/GetOptOutStatusTimerThresholdState`
const SET_OPT_OUT_STATUS_THRESHOLD = `${Env.REACT_APP_API_URL}Organization/api/Organization/SetOptOutStatusTimerThresholdState`

const DRUG_PRICE_CONFIG_BASE = `${Env.REACT_APP_API_URL}Organization/api/DrugPriceConfig`
const GET_ORG_DRUG_CONFIGS = `${DRUG_PRICE_CONFIG_BASE}/GetOrgConfigs`
const SAVE_DRUG_PRICE = `${DRUG_PRICE_CONFIG_BASE}/Save`
const UPDATE_DRUG_PRICE = `${DRUG_PRICE_CONFIG_BASE}/Update`
const DELETE_DRUG_PRICE = `${DRUG_PRICE_CONFIG_BASE}/Delete`
const BULK_UPLOAD_DRUG_PRICE = `${DRUG_PRICE_CONFIG_BASE}/BulkUploadDrugPrice`
const GET_ORG_DRUG_COMMUNITY_PRICES = `${DRUG_PRICE_CONFIG_BASE}/GetOrgDrugCommunityPrices`
const GET_DRUG_PRICE_THRESHOLD = `${DRUG_PRICE_CONFIG_BASE}/GetThreshold`
const SAVE_DRUG_PRICE_THRESHOLD = `${DRUG_PRICE_CONFIG_BASE}/SaveThreshold`
const SEARCH_NADAC_DRUGS = `${DRUG_PRICE_CONFIG_BASE}/SearchNadacDrugs`
const GET_DRUG_DETAIL = `${DRUG_PRICE_CONFIG_BASE}/GetDrugDetail`

export const organizationCreate = (
  organizationData: OrganizationDetailsRequest,
): Promise<OrganizationCreateResponse> =>
  HttpClient[ApiRequestTypes.post](ORGANIZATION_CREATE_BASE_URL, organizationData)
export const getAllFeaturesList = (): Promise<PromiseFeatureForm> =>
  HttpClient[ApiRequestTypes.get](GET_ALL_FEATURES_URL)

export const deleteOrganization = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](`${ORGANIZATION_DELETE_BASE_URL}?id=${id}`)
export const getOrganizationById = (id: number): Promise<OrganizationGetResponse> =>
  HttpClient[ApiRequestTypes.get](`${GET_ORGANIZATION_DATA}?id=${id}`)
export const updateOrganization = (
  organizationData: OrganizationDetailsRequest,
): Promise<Envelope> => HttpClient[ApiRequestTypes.put](PUT_ORGANIZATION_DATA, organizationData)
export const getFeatureList = (): Promise<FeatureListResponse> =>
  HttpClient[ApiRequestTypes.get](GET_ALL_FEATURES_URL)
export const getOrganizationDetails = (id: number): Promise<OrganizationGetResponse> =>
  HttpClient[ApiRequestTypes.get](`${GET_ORGANIZATION_DETAILS}?id=${id}`)
export const questionBankDetailList = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_QUESTION_BANK_DETAIL_LIST}?id=${id}`)
export const createOrUpdateQuestionBank = (data: QuestionBank): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](ADD_OR_UPDATE_QUESTIONBANK_URL, data)
export const deleteQuestion = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${QUESTION_DELETE_URL}?id=${id}`)
export const addCategory = (category: CreateCategory): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](ADD_CATEGORY_URL, category)
export const updateCategory = (category: UpdateCategory): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](UPDATE_CATEGORY_URL, category)

export const getCategories = (organizationId: number): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_CATEGORIES_URL}?organizationId=${organizationId}`)

export const addKeywords = (data: AddKeywordRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](ADD_KEYWORD_URL, data)
export const getSavedKeywords = (data: AddKeywordDataResponse): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_SAVED_KEYWORDS_URL}?categoryId=${data.categoryId}`)
export const getCategoriesForAddMore = (data: WordBankSelectedDeatil): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](
    `${GET_CATEGORIES_FOR_ADDMORE_URL}?organizationId=${data.organizationId}&facilityId=${data.facilityId}`,
  )

export const getWordBankDetailList = (organizationId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](
    `${GET_WORD_BANK_DETAIL_LIST_URL}?organizationId=${organizationId}`,
  )

export const deleteWordbank = (categoryId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](`${DELETE_WORD_BANK_URL}?id=${categoryId}`)

export const getAllFacilities = (organizationId: number): Promise<{ data: ListData[] }> =>
  HttpClient[ApiRequestTypes.get](`${GET_ALL_FACILITY_URL}?organizationId=${organizationId}`)

export const organizationStatusUpdate = (orgStatus: OrganizationStatusRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](PUT_ORGANIZATION_STATUS, orgStatus)

export const deleteCategory = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](`${DELETE_CATEGORY_URL}?id=${id}`)
export const updateQuestionBankPriorities = (
  data: UpdateQuestionBankPriorityReq,
): Promise<Envelope> => HttpClient[ApiRequestTypes.post](UPDATE_PRIORITY_URL, data)
export const createHra = (data: AddHraRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CREATE_HRA, data)
export const hasAIForQAConfigured = (id: number): Promise<AIForQAStatus> =>
  HttpClient[ApiRequestTypes.get](`${HAS_AI_CONFIGURED}?organizationId=${id}`)
export const getAutomationConfigs = (organizationId: number) =>
  HttpClient[ApiRequestTypes.get](`${GET_AUTOMATION_CONFIGS_URL}?organizationId=${organizationId}`)
export const updateAutomationConfigs = (data: AutomationConfig) =>
  HttpClient[ApiRequestTypes.post](UPDATE_AUTOMATION_CONFIGS_URL, data)

export const getRuleConfigById = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_RULE_CONFIG_BY_ID}?Id=${id}`)

export const createRule = (data: RulePayload): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CREATE_RULE, data)

export const updateRule = (data: RulePayload): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](UPDATE_RULE, data)
export const getRuleAssignRolesList = (data: RulesAssignRoleListReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_RULE_ASSIGN_ROLES_LIST, data)
export const getRuleAssignUsersList = (data: RuleAssignUserListReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_RULE_ASSIGN_USERS_LIST, data)
export const getCommunityCapability = (data: RulesListRequest) =>
  HttpClient[ApiRequestTypes.post](GET_COMMUNITY_CAPABILITIES, data)
export const createCommunityCapability = (data: CapabilityReq) =>
  HttpClient[ApiRequestTypes.post](CREATE_COMMUNITY_CAPABILITIES, data)
export const updateCommunityCapability = (data: CapabilityReq) =>
  HttpClient[ApiRequestTypes.post](UPDATE_COMMUNITY_CAPABILITIES, data)
export const deleteCommunityCapability = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_COMMUNITY_CAPABILITIES}?Id=${id}`)
export const updateStatusCommunityCapability = (data: CommunityCapabilityStatusReq) =>
  HttpClient[ApiRequestTypes.put](UPDATE_STATUS_COMMUNITY_CAPABILITIES, data)
export const uploadCommunityCapability = (
  data: UploadCommunityCapabilityParams,
): Promise<UploadFileResponse> => {
  const formData = new FormData()
  formData.append('File', data.file)

  return HttpClient[ApiRequestTypes.post](
    `${BULK_UPLOAD_COMMUNITY_CAPABILITIES}?OrganizationId=${data.organizationId}`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  )
}
export const bulkUploadCentralizedFax = (
  data: BulkUploadCentralizedFaxParams,
): Promise<BulkUploadCentralizedFaxResponse> => {
  const formData = new FormData()
  formData.append('File', data.file)
  formData.append('ExistingFaxNumbers', JSON.stringify(data.existingFaxNumbers))

  return HttpClient[ApiRequestTypes.post](
    `${BULK_UPLOAD_CENTRALIZED_FAX_URL}?OrganizationId=${data.organizationId}`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  )
}
export const getCommunityCapabilityById = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](`${GET_CAPABILITIES_BY_ID}?Id=${id}`, {})

export const getStatusThresholdConfigsByOrgId = (
  organizationId: number,
): Promise<StatusThresholdListResponse> =>
  HttpClient[ApiRequestTypes.get](
    `${GET_STATUS_THRESHOLD_LIST}?organizationId=${organizationId}`,
  )

export const getStatusThresholdByOrgAndStatus = (
  payload: GetStatusThresholdByOrgAndStatusRequest,
): Promise<StatusThresholdDetailResponse> =>
  HttpClient[ApiRequestTypes.post](GET_STATUS_THRESHOLD_BY_STATUS, payload)

export const saveStatusThresholdConfig = (
  payload: SaveStatusThresholdRequest,
): Promise<SaveStatusThresholdResponse> =>
  HttpClient[ApiRequestTypes.post](SAVE_STATUS_THRESHOLD, payload)

export const getOptOutStatusThresholdByOrgId = (
  organizationId: number,
): Promise<GetOptOutStatusThresholdResponse> =>
  HttpClient[ApiRequestTypes.get](
    `${GET_OPT_OUT_STATUS_THRESHOLD}?organizationId=${organizationId}`,
  )

export const setOptOutStatusThreshold = (
  payload: SetOptOutStatusThresholdRequest,
): Promise<SetOptOutStatusThresholdResponse> =>
  HttpClient[ApiRequestTypes.post](SET_OPT_OUT_STATUS_THRESHOLD, payload)

/** Paged list of the org's configured drug prices. `search` matches name/NDC/manufacturer. */
export const getOrgDrugConfigs = (
  data: DrugPriceListRequest,
): Promise<DrugPriceListResponse> =>
  HttpClient[ApiRequestTypes.post](GET_ORG_DRUG_CONFIGS, data)

/** Create an org-level drug price (level must be 1 = Organization). */
export const saveDrugPrice = (
  data: DrugPriceSaveRequest,
): Promise<DrugPriceStringResponse> =>
  HttpClient[ApiRequestTypes.post](`${SAVE_DRUG_PRICE}?level=1`, data)

/** Edit an org drug price and its changed community rows. */
export const updateDrugPrice = (
  data: DrugPriceUpdateRequest,
): Promise<DrugPriceStringResponse> =>
  HttpClient[ApiRequestTypes.post](UPDATE_DRUG_PRICE, data)

/** Soft-delete a single price row. `level` must match the target row's tier. */
export const deleteDrugPrice = (
  id: number,
  level: number,
): Promise<DrugPriceStringResponse> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_DRUG_PRICE}?id=${id}&level=${level}`)

/** Bulk create/update org-level prices from a CSV file. */
export const bulkUploadDrugPrice = (
  data: BulkUploadDrugPriceParams,
): Promise<BulkUploadDrugPriceResponse> => {
  const formData = new FormData()
  formData.append('OrganizationId', data.organizationId.toString())
  formData.append('File', data.file)

  return HttpClient[ApiRequestTypes.post](BULK_UPLOAD_DRUG_PRICE, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

/** Per-community resolved prices for one drug (Add/Edit grid). */
export const getOrgDrugCommunityPrices = (
  data: OrgDrugCommunityPriceRequest,
): Promise<OrgDrugCommunityPriceResponse> =>
  HttpClient[ApiRequestTypes.post](GET_ORG_DRUG_COMMUNITY_PRICES, data)

/** Get the org's high-cost threshold (null when unset). */
export const getDrugPriceThreshold = (
  organizationId: number,
): Promise<DrugPriceThresholdResponse> =>
  HttpClient[ApiRequestTypes.get](
    `${GET_DRUG_PRICE_THRESHOLD}?organizationId=${organizationId}`,
  )

/** Upsert the org's high-cost threshold. Send null to clear. */
export const saveDrugPriceThreshold = (
  payload: SaveThresholdRequest,
): Promise<DrugPriceStringResponse> =>
  HttpClient[ApiRequestTypes.post](SAVE_DRUG_PRICE_THRESHOLD, payload)

/** Search the NADAC drug list for the Add/Edit drug picker. */
export const searchNadacDrugs = (
  data: NadacDrugSearchRequest,
): Promise<NadacDrugSearchResponse> =>
  HttpClient[ApiRequestTypes.post](SEARCH_NADAC_DRUGS, data)

/** Reference detail (NADAC price / pricing unit / org price) for a selected drug. */
export const getDrugDetail = (
  organizationId: number,
  ndc: string,
): Promise<DrugDetailResponse> =>
  HttpClient[ApiRequestTypes.get](
    `${GET_DRUG_DETAIL}?organizationId=${organizationId}&ndc=${encodeURIComponent(ndc)}`,
  )
